/* Jason 04202026 */
document.addEventListener('teeinblue-event-component-injected', function() {
  const mainElement = document.querySelector('.tee-customize-main-form');

  if (!mainElement) {
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    const moveElement = document.querySelector('div[id*=selleasy_lb_upsell_widget]');
    if (moveElement) {
      mainElement.after(moveElement);
      obs.disconnect(); 
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


// document.addEventListener('teeinblue-event-component-injected', function() {
//   const elementToMove = document.querySelector('.tee-block.tee-product-price');
//   const insertAfterElement = document.querySelector('.jdgm-widget .jdgm-prev-badge');
//   if (elementToMove && insertAfterElement) {        
//     insertAfterElement.after(elementToMove);
//   } 
// });

// document.addEventListener('teeinblue-event-component-injected', () => {
//   moveElementAfter('[id*="x-estimate-delivery-container-template"]', '.tee-product-price');
// });
// const moveElementAfter = (target, after) => {
//   const targetEl = document.querySelector(target);
//   const afterEl = document.querySelector(after);
//   if (targetEl && afterEl) {
//     afterEl.after(targetEl);
//   }
// };